// extracted by mini-css-extract-plugin
module.exports = {"button":"WaffleToggleButtonStyles_button__ZcAo6","buttonText":"WaffleToggleButtonStyles_buttonText__2ybbj","arrow":"WaffleToggleButtonStyles_arrow__3OaAB"};